import React from "react"
import { Box, Loader } from "@strapi/design-system"

const PageLoader = () => (
  <div style={{ width: "100%", display: "flex", justifyContent: "center", height: "50vh" }}>
    <Box padding={4} className={"content-center"}>
      <Loader />
    </Box>
  </div>
)

export default PageLoader
